export const PATTERNS: string[] = [
  "M10 10L90 90M90 10L10 90",  // X pattern
  "M0 50H100M50 0V100",        // + pattern
  "M25,25 L75,25 L75,75 L25,75 Z", // Square pattern
  "M50,25 L75,75 L25,75 Z",    // Triangle pattern
  "M0,0 L100,100",             // Diagonal line
  "M50,0 L100,50 L50,100 L0,50 Z", // Diamond
  "M0,0 Q50,100 100,0",        // Curve
  "M25,0 L75,0 L100,50 L75,100 L25,100 L0,50 Z", // Hexagon
  "M50,0 A50,50 0 0,1 50,100 A50,50 0 0,1 50,0", // Circle
  "M0,0 L100,0 L100,100 L0,100 Z M25,25 L75,25 L75,75 L25,75 Z", // Square frame
  "M0,0 L50,50 L0,100 M100,0 L50,50 L100,100", // Chevron
  "M25,60 a20,20 0 1,0 50,0 a20,20 0 1,0 -50,0", // Infinity symbol
  "M0,40 Q50,0 100,40 Q50,80 0,40", // Wave
  "M0,0 L50,50 L100,0 M0,100 L50,50 L100,100", // Hourglass
  "M0,0 L100,0 L50,100 Z M0,100 L100,100 L50,0 Z", // Star
  "M25,25 C25,75 75,75 75,25", // S curve
  "M0,0 L100,100 M20,0 L100,80 M40,0 L100,60 M60,0 L100,40 M80,0 L100,20", // Rain
  "M0,0 Q50,100 100,0 T200,0", // Double curve
  "M0,0 L100,0 L50,100 Z M25,50 L75,50 L50,100 Z", // Layered triangles
  "M50,0 L100,50 L50,100 L0,50 Z M25,50 L75,50 M50,25 L50,75", // Diamond with cross
  "M0,0 L100,0 L100,100 L0,100 Z M0,50 L100,50 M50,0 L50,100", // Grid
  "M0,0 Q50,100 100,0 Q50,-100 0,0", // Leaf
  "M25,25 L75,25 A50,50 0 0,1 75,75 L25,75 A50,50 0 0,1 25,25", // Rounded square
  "M0,0 L100,0 L75,50 L100,100 L0,100 L25,50 Z", // Hexagon variation
  "M0,40 C50,70 50,30 100,60", // Sinusoidal wave
  "M0,0 Q25,25 0,50 Q25,75 0,100 M100,0 Q75,25 100,50 Q75,75 100,100", // Double wave edges
  "M0,0 L100,0 L100,100 L0,100 Z M0,0 Q50,50 0,100 M100,0 Q50,50 100,100", // Eye
  "M0,0 C50,-50 50,50 100,0 C50,50 50,-50 0,0", // Infinity loops
];

export const COLORS: string[] = [
  '#FF0000', // Red
  '#00FF00', // Lime Green
  '#0000FF', // Blue
  '#FF00FF', // Magenta
  '#000000', // Black
  '#FF4500', // Orange Red
  '#1E90FF', // Dodger Blue
  '#32CD32', // Lime Green
  '#8B008B', // Dark Magenta
  '#2F4F4F', // Dark Slate Gray
  '#800000', // Maroon
  '#008080', // Teal
]

export const PRIORITY_ORDER = ['MET_CALL', 'URGENT_ASSESSMENT','CRITICAL_CARE']
export const PRIORITY_VALUES = {
  MET_CALL: 0,
  URGENT_ASSESSMENT: 1,
  CRITICAL_CARE: 2,
} as const;

export const PRIORITY_LABELS = {
  0: 'MET Call',
  1: 'Urgent Assessment',
  2: 'Critical Care',
} as const;


export const MESSAGE_NO_DATA = "No Data / No Priority Patterns for Visualization"
export const MESSAGE_LOADING = "Loading..."
export const MESSAGE_TIMERANGE = "Select Time Range for Visualizations"